var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33.8 15.2l-9-9.9h-15c-.6 0-1.1.5-1.1 1.1v29.7c0 .6.5 1.1 1.1 1.1h22.8c.6 0 1.1-.5 1.1-1.1V15.2h-9V5.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSimple);
export default __webpack_public_path__ + "static/media/fileSimple.a11279c96caf486904f4451e45929dd9.svg";
export { ForwardRef as ReactComponent };